var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus2 = function SvgPlus2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 13.3333V8.49999H2.66699C2.39085 8.49999 2.16699 8.27613 2.16699 7.99999C2.16699 7.72385 2.39085 7.49999 2.66699 7.49999H7.50033V2.66666C7.50033 2.39051 7.72418 2.16666 8.00033 2.16666C8.27647 2.16666 8.50033 2.39051 8.50033 2.66666V7.49999H13.3337C13.6098 7.49999 13.8337 7.72385 13.8337 7.99999C13.8337 8.27613 13.6098 8.49999 13.3337 8.49999H8.50033V13.3333C8.50033 13.6095 8.27647 13.8333 8.00033 13.8333C7.72418 13.8333 7.50033 13.6095 7.50033 13.3333Z",
    fill: "currentColor"
  })));
};
export default SvgPlus2;